// The photographer guide: a Playbook (how to approach people) and a Workflow (from signup to
// payout), both as PDFs in /static/guides, one per language.
//
// Whether a photographer has dealt with it is kept in the user's private data:
//   privateData.photographerGuide = { version, confirmedAt, snoozedUntil }
// The guide is a recommendation, not a gate: the photographer can confirm it ("read and
// understood") or skip it for now, which hides the reminder for SNOOZE_DAYS.

import { getUserRole } from './helper';

// Raise this when the content changed so much that photographers should read it again.
export const GUIDE_VERSION = 1;
// Raise this with every re-export of a PDF so browsers do not show an old copy.
export const GUIDE_FILES_REVISION = 1;
export const SNOOZE_DAYS = 7;

export const GUIDE_DOCUMENTS = ['Playbook', 'Workflow'];

export const guidePdfUrl = (document, locale) =>
  `/static/guides/Sihmo-${document}-${locale === 'de' ? 'de' : 'en'}.pdf?v=${GUIDE_FILES_REVISION}`;

const guideState = user => user?.attributes?.profile?.privateData?.photographerGuide || {};

export const guideConfirmedAt = user => {
  const { version, confirmedAt } = guideState(user);
  return confirmedAt && Number(version) >= GUIDE_VERSION ? confirmedAt : null;
};

const isSnoozed = (user, now) => {
  const { snoozedUntil } = guideState(user);
  return !!snoozedUntil && new Date(snoozedUntil).getTime() > now;
};

export const shouldShowGuideReminder = (user, now = Date.now()) =>
  getUserRole(user) === 'photographer' && !guideConfirmedAt(user) && !isSnoozed(user, now);

export const confirmedGuideState = (now = Date.now()) => ({
  version: GUIDE_VERSION,
  confirmedAt: new Date(now).toISOString(),
});

// Skipping keeps an earlier confirmation of an older version out of the way, too.
export const snoozedGuideState = (user, now = Date.now()) => ({
  ...guideState(user),
  snoozedUntil: new Date(now + SNOOZE_DAYS * 24 * 60 * 60 * 1000).toISOString(),
});
